import PropTypes from 'prop-types'
import styled from 'styled-components'
import { t, jt } from 'ttag'

import { features } from '@h2/components/media'
import { SLB } from '@h2/components/colors'
import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { Checklist } from '@h2/components/containers/checklist'
import { Heading } from '@h2/components/typography/heading'
import { Icon as IconComponent } from '@h2/components/display/icon'
import actionSvg from '@h2/assets/svg/home/source/action.svg'
import { Panel } from '@h2/common/components/panel'

import { WorkingWithOthers } from './workingWithOthers'

const Icon = styled(IconComponent)`
  position: relative;

  svg {
    clip-path: inset(0 0 0 36px);
    margin-right: 37px;
  }
`
const WorkingBox = styled(Box)`
  display: none;

  @media (${features.minWidth.desktop}) {
    display: block;
    margin-left: 20px;
  }
`
const FlexWrap = styled(Flex)`
  @media (${features.minWidth.desktop}) {
    flex-direction: row;
    padding: 50px 0;

    h2 {
      font-size: 34px;
      margin-top: 0;
    }

    > div:first-child {
      order: 2;
      position: relative;
      top: 25px;
      left: -30px;

      svg {
        margin: 0;
        width: 350px;
        clip-path: unset;
      }
    }

    > div:nth-child(2) {
      order: 1;

      ul {
        font-size: 20px;
        line-height: 24px;
      }
    }

    > div:last-child {
      order: 3;
    }

    @media (${features.maxWidth.widescreen}) {
      > div:first-child {
        top: 0;
        left: -15px;

        svg {
          width: 300px;
        }
      }
    }
  }
`
const action = <span key="track">{t`take action`}</span>
const TakeAction = ({ systemName }) => {
  return (
    <Panel>
      <FlexWrap direction="column" alignItems="center" padding="30px 20px">
        <Box>
          <Icon
            isCentered
            label="take action"
            width="270px"
            height="auto"
            dangerouslySetGlyph={actionSvg}
          />
        </Box>
        <Box>
          <Heading
            level="2"
            weight="light"
            mb="15px"
            mt="20px"
            mark="span"
            markColor={SLB}
            variant="mixed-weight">
            {jt`Time to ${action}`}
          </Heading>
          <Heading level="4" mb="15px" variant="font" weight="bold">
            {t`Acting on your plan is just as important as creating it. The ${systemName} helps you:`}
          </Heading>
          <Box px="5px">
            <Checklist variant="leading-down">
              <Checklist.Item>{t`Clearly see where you are in the process`}</Checklist.Item>
              <Checklist.Item>{t`Keep track of your goals`}</Checklist.Item>
              <Checklist.Item>
                {t`Stay on top of the steps you need to take`}
              </Checklist.Item>
            </Checklist>
          </Box>
        </Box>
        <WorkingBox>
          <WorkingWithOthers type="action" shade="blue" size="small" />
        </WorkingBox>
      </FlexWrap>
    </Panel>
  )
}

TakeAction.propTypes = {
  systemName: PropTypes.string.isRequired
}

export { TakeAction }
